/**
 * Boards selectors
 */

import { RootState } from "types";

import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./initialState";

// TODO: Add an explanation for this
const selectDomain = (state: RootState) => state?.boardsState || initialState;

export const selectBoards = createSelector(
  [selectDomain],
  (state) => state.boardsData,
);

export const selectFavorites = createSelector(
  [selectDomain],
  (state) => state.favorites,
);

export const selectQaBoards = createSelector(
  [selectDomain],
  (state) => state.qaBoards,
);

export const selectRecent = createSelector(
  [selectDomain],
  (state) => state.recent,
);
export const selectBoardsFormData = createSelector(
  [selectDomain],
  (state) => state.boardsForm,
);
export const selectDefaultTicketValueData = createSelector(
  [selectDomain],
  (state) => state.defaultTicketValueData,
);
export const selectDraftTicket = createSelector(
  [selectDomain],
  (state) => state.draftTicket,
);

export const selectSelectedTickets = createSelector(
  [selectDomain],
  (state) => state.selectedTickets,
);
export const selectIsFileUploading = createSelector(
  [selectDomain],
  (state) => state.isFileUploading,
);
export const selectIsFilePreview = createSelector(
  [selectDomain],
  (state) => state.isFilePreview,
);
export const selectUploadProgress = createSelector(
  [selectDomain],
  (state) => state.uploadProgress,
);

export const selectSortByColumn = createSelector(
  [selectDomain],
  (state) => state.sortByColumn,
);

export const selectSortByOrder = createSelector(
  [selectDomain],
  (state) => state.sortByOrder,
);

export const selectIsLoading = createSelector(
  [selectDomain],
  (state) => state.isLoading,
);
export const selectSelectedBoard = createSelector(
  [selectDomain],
  (state) => state.selectedBoard,
);
export const selectBoardLoading = createSelector(
  [selectDomain],
  (state) => state.boardLoading,
);

// Ticket Description related selectors --
export const selectEnableTicketDescription = createSelector(
  [selectDomain],
  (state) => state?.enableTicketDescription,
);

export const selectEnableAddNewTemplateForm = createSelector(
  [selectDomain],
  (state) => state?.enableAddNewTemplateForm,
);
